module.exports = __webpack_public_path__ + "static/img/TT.43237920.png";